import React from "react";
import get from "lodash/get";
import { object, number, array } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import ResponsiveSourceImage from "../../atoms/responsive-source-image/index";
import PlaceholderImage from "../../atoms/placeholder-image";

import "./card-image-type-4.m.css";

const CardImageType4 = ({ story, headlineLimit, desktopWidths = [250, 480, 640], mobileWidths = [250, 480, 640] }) => {
  const storyObj = story.story ? story.story : story;
  const slug = storyObj["hero-image-s3-key"];
  const storyImageSlug = get(storyObj, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);
  return (
    <Link href={`/${storyObj.slug}`}>
      <div styleName="wrapper" className="card-image-type-4">
        {storyImageSlug ? (
          <ResponsiveSourceImage
            story={storyObj}
            desktopAspectRation={[16, 9]}
            mobileAspectRation={[1, 1]}
            desktopWidths={desktopWidths}
            mobileWidths={mobileWidths}
          />
        ) : (
          <PlaceholderImage className={"placeholder-image"} story={storyObj} />
        )}
        <div styleName="headline">
          <Headline story={storyObj} headerType={19} headerLevel={2} headlineLimit={headlineLimit} />
        </div>
      </div>
    </Link>
  );
};

export default CardImageType4;

CardImageType4.propTypes = {
  story: object,
  headlineLimit: number,
  desktopWidths: array,
  mobileWidths: array
};
